import {memo, useRef} from 'react';
import {useTooltipTriggerState} from '@react-stately/tooltip';
import {useTooltipTrigger} from '@react-aria/tooltip';

import {BUTTON_SIZE, IconButton, Tooltip, TooltipTextPrimary} from 'packages/ui-kit';

import styles from './rhs_header_icon_button.module.css';

type Props = {
    icon: React.ReactNode;
    size?: BUTTON_SIZE;
    className?: string;

    tooltipDelayShow?: number;
    tooltipDelayClose?: number;
    tooltipText?: React.ReactNode;
    tooltipNode?: React.ReactNode;

    onPress: () => void;
};

const TOOLTIP_TRIGGER_PROPS = {};

const RhsHeaderIconButton: React.FC<Props> = ({
    icon,
    size = BUTTON_SIZE.SMALL,
    className = styles.btn,
    tooltipDelayShow = 0,
    tooltipDelayClose = 0,
    tooltipText,
    tooltipNode,
    onPress,
}) => {
    const triggerRef = useRef<HTMLDivElement>(null);

    const tooltipTriggerState = useTooltipTriggerState({delay: tooltipDelayShow, closeDelay: tooltipDelayClose});
    const {triggerProps, tooltipProps} = useTooltipTrigger(TOOLTIP_TRIGGER_PROPS, tooltipTriggerState, triggerRef);
    const hasTooltip = Boolean(tooltipText) || Boolean(tooltipNode);

    return (
        <>
            <div
                {...triggerProps as React.ComponentProps<typeof IconButton>}
                ref={triggerRef}
            >
                <IconButton
                    size={size}
                    flat={true}
                    icon={icon}
                    onPress={onPress}
                    className={className}
                />
            </div>
            {hasTooltip && tooltipTriggerState.isOpen && (
                <Tooltip
                    {...tooltipProps}
                    className={styles.tooltip}
                    targetRef={triggerRef}
                    state={tooltipTriggerState}
                >
                    {tooltipText && <TooltipTextPrimary>{tooltipText}</TooltipTextPrimary>}
                    {tooltipNode}
                </Tooltip>
            )}
        </>
    );
};

export default memo(RhsHeaderIconButton);
